export const DSTag = () => <span style={prismTagStyles}>Prism</span>;

export const prismTagStyles = {
  backgroundColor: 'rgb(5, 130, 112)',
  backgroundImage:
    'linear-gradient(120deg,rgba(0, 47, 97, 1) 0%, rgba(44, 101, 145, 1) 35%, rgba(2, 121, 131, 1) 65%, rgba(4, 126, 121, 1) 100%)',
  color: 'rgb(255, 255, 255)',
  borderRadius: 24,
  padding: '2px 8px',
  fontWeight: 600,
  fontSize: '12px',
};
